/**
 * "View": a soft green pill button in the PersonPill tokens. It fills with
 * Tadpole green on hover and shows a green ring when focused by keyboard.
 */
export default function ViewButton({
  label,
  onClick,
}: {
  /** What it opens, for screen readers ("View Pat Lee's responses"). */
  label: string;
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      aria-label={label}
      title={label}
      onClick={onClick}
      className="inline-flex items-center rounded-full border border-[rgba(var(--green-rgb),0.35)] bg-[rgba(var(--green-rgb),0.08)] px-3 text-xs font-semibold leading-5 text-[#07854b] transition-colors duration-150 hover:border-[rgb(var(--green-rgb))] hover:bg-[rgb(var(--green-rgb))] hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-[rgb(var(--green-rgb))] focus-visible:ring-offset-2"
    >
      View
    </button>
  );
}
